import { Check, X } from "lucide-react";
import { COMPARISON } from "@/data/site";
import { Eyebrow, FadeIn } from "@/components/blocks";

export default function Comparison() {
  return (
    <section data-testid="comparison-section" className="bg-bone px-6 py-28 text-ink sm:px-10 sm:py-36 lg:px-16">
      <div className="mx-auto max-w-[1440px]">
        <FadeIn>
          <Eyebrow tone="ink">The Difference</Eyebrow>
        </FadeIn>
        <FadeIn delay={0.1}>
          <h2 className="mt-8 max-w-4xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
            Live 1:1 <span className="text-ink/40">vs generic workout apps.</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} className="mt-16 border border-ink/15">
          <div className="grid border-b border-ink/15 bg-ink/[0.03] sm:grid-cols-[160px_1fr_1fr]">
            <div className="hidden sm:block" />
            <p className="px-6 py-5 font-mono text-[11px] uppercase tracking-[0.25em] text-ink/45 sm:border-l sm:border-ink/15">
              Generic fitness apps
            </p>
            <p className="flex items-center gap-3 border-t border-ink/15 px-6 py-5 font-mono text-[11px] uppercase tracking-[0.25em] text-ink sm:border-l sm:border-t-0">
              <span className="inline-block h-1.5 w-1.5 bg-lime" />
              StrengthLeap Live 1:1
            </p>
          </div>
          {COMPARISON.map((row, i) => (
            <div
              key={row.label}
              data-testid={`comparison-row-${i}`}
              className="grid border-b border-ink/15 last:border-b-0 sm:grid-cols-[160px_1fr_1fr]"
            >
              <p className="px-6 pt-5 font-mono text-[10px] uppercase tracking-[0.25em] text-ink/50 sm:py-6">
                {row.label}
              </p>
              <p className="flex items-start gap-3 px-6 py-3 text-sm leading-relaxed text-smoke sm:border-l sm:border-ink/15 sm:py-6 sm:text-base">
                <X className="mt-0.5 h-4 w-4 shrink-0 text-ink/30" />
                {row.app}
              </p>
              <p className="flex items-start gap-3 px-6 pb-5 pt-1 text-sm font-medium leading-relaxed text-ink sm:border-l sm:border-ink/15 sm:py-6 sm:text-base">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-ember" />
                {row.live}
              </p>
            </div>
          ))}
        </FadeIn>
      </div>
    </section>
  );
}
